// extracted by mini-css-extract-plugin
export var buttonContent = "_3d-0";
export var centered = "_3d-1";
export var centeredFlex = "_3d-2";
export var errorText = "_3d-3";
export var icon = "_3d-4";
export var iconButtonContent = "_3d-5";
export var monospace = "_3d-6";
export var padded = "_3d-7";